import { render, staticRenderFns } from "./MediaCreate.vue?vue&type=template&id=6f1d9dda&"
import script from "./MediaCreate.vue?vue&type=script&lang=ts&"
export * from "./MediaCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports